var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVwing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 36,
    viewBox: "0 0 33.623 14.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    d: "M184.225,415.834h-8.543a1.765,1.765,0,0,0-1.362.643c-.974,1.179-3.34,3.564-6.12,3.605-2.779-.042-5.146-2.427-6.119-3.605a1.765,1.765,0,0,0-1.362-.643h-8.543a.785.785,0,0,0-.5,1.391l15.436,12.732a1.645,1.645,0,0,0,2.175,0l15.436-12.732A.785.785,0,0,0,184.225,415.834Z",
    transform: "translate(-151.389 -415.834)",
    fill: "#017bff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVwing);
export default __webpack_public_path__ + "static/media/vwing.af6bedb4186f693e9c23b4211d497cf9.svg";
export { ForwardRef as ReactComponent };